import React, {Fragment} from "react";
import {Col, Image, Row, Tab, Tabs} from "react-bootstrap";
import {useNavigate} from "react-router-dom";
import PlateAteModal from "./PlateAteModal";
import Badge from "react-bootstrap/Badge";
import ItemImage from "../../shared/ItemImage";
import PlateNotAteModal from "./PlateNotAteModal";
import {CustomButton} from "../../../helpers/ButtonHelper";
import {useMutation} from "@apollo/client";
import {AddToCartMutation} from "./ClientPlateQueries";
import {getCartItems} from "../shopping/CartQueries";

const ClientPlatesList = ({ menu, refetch }) => {
  const navigate = useNavigate()
  const [addToCartCall] = useMutation(AddToCartMutation, { refetchQueries: [getCartItems] })
  let showDay = false
  let menuDay = null;

  const addToCart = (item) => {
    addToCartCall({
      variables: { id: item.plate.id },
      onCompleted: () => {
        navigate('/shopping_list')
      }
    })
  }

  const navigateToPlate = (item) => {
    if (!item.active)
      return;
    const itemUrl = `/my_menu_items/${item.id}`
    navigate(itemUrl)
  }

  const listItem = (item, index) => {

    if (menuDay !== item.day) {
      menuDay = item.day
      showDay = true
    } else
      showDay = false

    const pointerClass = item.active && 'pointer'
    return (
      <Fragment key={index}>
        {showDay &&
          <Badge className="bg-branding w-100 p-2 mt-3 fs-6"><strong>Ziua {menuDay}</strong></Badge>
        }
        <div className={`fs-5 mt-3 rounded shadow p-1 pt-3 px-2 mx-0 bg-white ${pointerClass}`}>
          <Row>
            <Col className='col-auto mb-3' onClick={() => navigateToPlate(item)} style={{ width: '120px' }}>
              {item.history && item.history.image
                ?
                <Image rounded src={item.history.image} width={100} height={100}
                       className="rounded object-fit-cover"></Image>
                :
                <ItemImage src={item.plate.image} width={100} height={100}
                           className="rounded object-fit-cover"></ItemImage>
              }
            </Col>
            <Col>
              <Row>
                <Col sm onClick={() => navigateToPlate(item)}
                     className="d-flex justify-content-between w-100 flex-wrap">
                  <Badge className='bg-light-branding border mb-1'>
                    {item.category.name}
                    {item.category.time && <>&nbsp;<em>({item.category.time})</em></>}
                  </Badge>
                  {item.active &&
                    <CustomButton icon='cart' text="Adauga in cos" className='btn btn-outline-primary float-end me-sm-2'
                                  size='sm'
                                  onClick={() => addToCart(item)}></CustomButton>}
                  {!item.active &&
                    <Fragment>
                      {item.history.ate ?
                        <Badge bg='primary' className="border border-dark mb-1">Am mancat</Badge>
                        :
                        <Badge bg='secondary' className="border border-dark mb-1">Nu am mancat</Badge>
                      }
                    </Fragment>
                  }

                </Col>
              </Row>
              <Row>
                <Col sm className="menu-title" onClick={() => navigateToPlate(item)}>
                  {item.plate.name}
                </Col>
              </Row>
              <Row>
                <Col sm onClick={() => navigateToPlate(item)}>
                  {item.plate.description}
                </Col>
              </Row>
            </Col>
          </Row>
          <Row className="mb-2">
            <Col>
              <Row>
                {item.active &&
                  <Col className='d-flex justify-content-around gap-2'>
                    {/*<PlateAlternativesModal showButton={true}></PlateAlternativesModal>*/}
                    <PlateAteModal showButton={true} item={item} refetch={refetch}></PlateAteModal>
                    <PlateNotAteModal showButton={true} item={item} refetch={refetch}></PlateNotAteModal>
                  </Col>
                }
              </Row>
            </Col>
          </Row>
        </div>
      </Fragment>
    )
  }

  const platesList = [].concat(menu.menuItems)
    .sort((a, b) => a.day > b.day ? 1 : -1)
    .map((item, index) => {
      if (item.active)
        return listItem(item, index)
      return null
    })

  const historyList = [].concat(menu.menuItems)
    .sort((a, b) => a.day > b.day ? 1 : -1)
    .map((item, index) => {
      if (!item.active)
        return listItem(item, index)
      return null
    })

  return (
    <div className="row justify-content-md-center px-3 pb-4 bg-body border rounded pt-3 shadow">
      <Tabs variant='pills' fill className="pe-0 gap-2">
        {menu.menuItems &&
          <Tab title='Mese' eventKey='menuItems'>
            {platesList}
          </Tab>
        }
        {menu.menuItems &&
          <Tab title='Istoric' eventKey='historyItems'>
            {historyList}
          </Tab>
        }
      </Tabs>
    </div>
  )
};

export default ClientPlatesList;
